import { ChevronRight } from '@/src/assets/icons/ChevronRight'
import { fontFamilies, mesaColorNames } from '@/src/common/theme'
import {
  type ComponentRef,
  forwardRef,
  type ComponentProps,
  type FunctionComponent,
  type PropsWithChildren,
} from 'react'
import { TouchableOpacity, StyleSheet } from 'react-native'
import Svg from 'react-native-svg'
import { View } from 'tamagui'

export const ScheduledPaymentEntryPoint = forwardRef<
  ComponentRef<typeof TouchableOpacity>,
  Pick<ComponentProps<typeof TouchableOpacity>, 'style' | 'onPress' | 'testID'> & {
    Icon: FunctionComponent<ComponentProps<typeof Svg>>
    iconStyle?: ComponentProps<typeof Svg>['style']
    chevronStyle?: ComponentProps<typeof ChevronRight>['style']
    chevronWrapperProps?: ComponentProps<typeof View>
  } & PropsWithChildren
>(
  (
    {
      Icon,
      iconStyle,
      chevronStyle,
      chevronWrapperProps,
      children,
      // spread is required to allow `asChild`-supporting parents to pass their non-standard props to the top-level element of this component
      ...props
    },
    ref,
  ) => {
    const style = StyleSheet.flatten([styles.container, props.style])
    const body = (
      <>
        <Icon height={24} width={24} style={[styles.icon, iconStyle]} />
        {children}
        <View
          {...chevronWrapperProps}
          style={[styles.icon, { marginLeft: 'auto' }, chevronWrapperProps?.style]}
        >
          <ChevronRight style={chevronStyle} color={mesaColorNames['Greyscale/500 #6E7375']} />
        </View>
      </>
    )

    return props.onPress ? (
      // spread is required to allow `asChild`-supporting parents to pass their non-standard props to the top-level element of this component
      <TouchableOpacity ref={ref} {...props} style={style}>
        {body}
      </TouchableOpacity>
    ) : (
      // spread is required to allow `asChild`-supporting parents to pass their non-standard props to the top-level element of this component
      <View ref={ref} {...props} style={style}>
        {body}
      </View>
    )
  },
)

export const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },
  icon: {
    flexShrink: 0,
  },
  title: {
    fontFamily: fontFamilies['PlusJakartaSans-Regular'],
    fontWeight: 400,
    fontSize: 14,
    flexShrink: 1,
  },
})
